<template>
<div class="box mt-5">
  <div class="row">
    <div class="col-md-12 m-3">
      <h3> Discounts <ShowHideEye :showSection="showSection" @toggle="showSection = !showSection"/> </h3>
    </div>
  </div>
  <div class="row"  v-if="showSection">
    <div class="col-md-12">
      <form class="form wrap form--inline" v-on:submit.prevent="addDiscount">
          <div v-if="discounts">
            <label>Discount</label>
            <v-select
              required
              id="discount"
              v-model="newDiscount"
              label="code"
              placeholder="Select a discount"
              :options="discounts"
            >
              <template slot="option" slot-scope="option">
                <span v-if="option.penalty_type == 0">
                  {{ option.code }} - {{ option.value | formatCurrency }}
                </span>
                <span v-else>
                  {{ option.code }} - {{ option.value }}%
                </span>
              </template>
            </v-select>
          </div>
  
          <div v-if="!isManual">
              <label for="checkbox">Show suppressed?</label>
              <label class="switch">
                  <input id="checkbox" type="checkbox" v-model="suppressedFlag" v-on:change="getDiscounts" />
                  <span class="switch__slider"></span>
              </label>
          </div>
  
          <div v-if="!isManual">
            <label for="qty">Quantity</label>
            <input type="number" id="qty" v-model="newDiscountQty" min="1">
          </div>
          <div v-if="isManual">
            <label for="discount_amount">Discount Amount</label>
            <input type="number" id="discount_amount" placeholder="Discount Amount" min="1" step="0.01" v-model="manualDiscountAmount">
          </div>
  
          <button type="submit" class="button button--small" v-if="userRole == 1">Add discount to booking</button>
      </form>
  
      <table class="table" cellspacing="0" cellpadding="0">
        <thead>
          <tr>
            <th>Discount code</th>
            <th>Description</th>
            <th>Value</th>
            <th>Quantity</th>
            <th>Total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(discount, index) of bookingDiscounts" :key="discount.id" >
            <td>{{ discount.code }}</td>
            <td>{{ discount.description }}</td>
            <td v-if="Number(discount.manual_discount_price) > 0">{{ Number(discount.manual_discount_price) | formatCurrency  }}</td>
            <td v-else-if="discount.penalty_type == 0">{{ discount.value | formatCurrency }}</td>
            <td v-else>{{ discount.value }}% (of <span v-if="discount.on_base_price == 0">{{ toursTotalPrice | formatCurrency }})</span><span v-else>{{ toursBasePrice | formatCurrency }})</span></td>
            
            <td>{{ discount.qty }}</td>
            <td v-if="Number(discount.manual_discount_price) > 0">{{ Number(discount.manual_discount_price) | formatCurrency  }}</td>
            <td v-else-if="discount.penalty_type == 0">{{ (discount.value * discount.qty) | formatCurrency }}</td>
            <td v-else><span v-if="discount.on_base_price == 0">{{ ((discount.value * toursTotalPrice) / 100 ) | formatCurrency}}</span><span v-else>{{ ((discount.value * toursBasePrice) / 100 ) | formatCurrency}}</span></td>          
            <td class="table-action"><a v-on:click="deleteDiscount(discount.booking_discount_attached_id)" class="icon icon--delete" v-if="userRole == 1">Delete</a></td>
          </tr>
          <tr>
            <td colspan="4"></td>
            <td><strong>{{ discountsTotalPrice | formatCurrency }}</strong></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

  
</template>

<script>
import ShowHideEye from './ShowHideEye.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'BookingDiscounts',
  components: { ShowHideEye },
  props : {
    toursTotalPrice: Number,
    toursBasePrice: Number,
    booking: Object,
    bookingDiscounts: Array,
    discountsTotalPrice: Number,
    tourIds: Array
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      let user_role = localStorage.getItem("user_role");
      if (user_role == 1) {
        this.showSection = true
      }
      return user_role
    },
    isManual() {
      if (this.newDiscount) {
        return this.newDiscount.is_manual
      }
    }
  },
  watch: {
    booking: {
        handler(newData) {
          if (newData.flat_discount) {
            this.openDiscount = true
            this.flatDiscountAmt = newData.flat_discount
          }
          
        },
        deep: true,
        immediate: true
      }
  },
  mounted () {
    this.getDiscounts()
    this.userRole
  },
  data () {
    return {
      discounts: null,
      newDiscount: null,
      openDiscount: false,
      flatDiscountAmt:null,
      suppressedFlag: null,
      newDiscountQty: 1,
      showSection: false,
      manualDiscountAmount:0
    }
  },
  methods: {
    getDiscounts () {
      // @TODO: Old load up global discounts and those that are linked to a tour that has an id within the booking.tour_bookings array
      this.$store.dispatch('setLoadStatus')
      var qs = [];
      if (this.tourIds) {
        for (let id of this.tourIds) {
          qs.push( 'tour_ids[]=' + id)
        }
      }

      if (this.suppressedFlag == true){
        this.suppressedFlag = 1
        qs.push("show_suppressed=" + this.suppressedFlag)
      }
      
      qs.push('fromAdmin=yes');

      fetch(this.$api + 'discounts?' + qs.join('&'), {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.discounts = response.data
        this.$store.dispatch('setLoadStatus')
      })
    },
    addDiscount () {   
      // this.newDiscount.pivot = {}
      // this.newDiscount.pivot.qty = this.newDiscountQty
      // this.booking.discounts.push(this.newDiscount)

      let discountFields = {
        holiday_booking_id: this.$route.params.id,
        discount_applied_id: this.newDiscount.id,
        discount_applied_qty: (this.isManual) ? 1 : this.newDiscountQty,
        manual_discount_amount:this.manualDiscountAmount
      }

      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'update-booking/update-discount', {
        method: 'POST',
        body: JSON.stringify(discountFields),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.status) {
          this.resetForm()
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.$emit('handleBooking')
        } else if (response.errors) {

          this.$notify({
            type: 'error',
            title: response.message
          });
          
        }

        this.$store.dispatch('setLoadStatus')
      });


    },
    deleteDiscount(index) {

      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'update-booking/delete-discount', {
        method: 'POST',
        body: JSON.stringify({
          discount_id:index
        }),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.status) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.$emit('handleBooking')
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
          
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    resetForm() {
      this.newDiscount = null
      this.suppressedFlag = null
      this.newDiscountQty = 0
      this.manualDiscountAmount = 0;
    }
  }
}
</script>